import { StyleSheet } from 'react-native';

import { neutralDark, warrior } from '../../constants/color';

const styles: any = StyleSheet.create({
  counter: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  counterDisplay: {
    color: warrior,
    minWidth: 20,
    fontSize: 15,
    lineHeight: 21,
    marginHorizontal: 16,
    textAlign: 'center',
  },
  counterHandler: {
    width: 30,
    height: 30,
    borderRadius: 3,
    borderColor: neutralDark,
    borderWidth: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  disabledHandler: {
    opacity: 0.4,
  },
  disabledCounterText: {
    opacity: 0.6,
    marginHorizontal: 0,
  },
});

export default styles;
